import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';

import useAuth from '../auth/context/auth';
import { ADMINISTRATOR } from '../../constants/userRoles';
import PublicJob from '../job/public/PublicJob';
import AdminJob from '../job/admin/AdminJob';

const useStyles = makeStyles(() => ({
  root: {
    margin: '0 2.5vw',
    width: '95vw',
  },
}));

const Main = () => {
  const classes = useStyles();
  const history = useHistory();
  const { userAttributes } = useAuth();

  const isAdmin = useMemo(() => {
    if (userAttributes) {
      const { profile: userRoles = [] } = userAttributes;
      return userRoles && userRoles.includes(ADMINISTRATOR);
    }

    return false;
  }, [userAttributes]);

  if (history.location.state && history.location.state.errorMessage) {
    toast.error(history.location.state.errorMessage);
    const state = { ...history.location.state };
    delete state.errorMessage;
    history.replace({ ...history.location, state });
  }

  return (
    <div className={classes.root}>{isAdmin ? <AdminJob /> : <PublicJob />}</div>
  );
};

export default Main;
